import { render, staticRenderFns } from "./PolicyHolderContainer.vue?vue&type=template&id=671636e7&scoped=true&"
import script from "./PolicyHolderContainer.vue?vue&type=script&lang=js&"
export * from "./PolicyHolderContainer.vue?vue&type=script&lang=js&"
import style0 from "./PolicyHolderContainer.vue?vue&type=style&index=0&id=671636e7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671636e7",
  null
  
)

export default component.exports